document.addEventListener('DOMContentLoaded', () => {
    const blueCircle = document.querySelector('.rewards-page__bg-circle--blue');
    const purpleCircle = document.querySelector('.rewards-page__bg-circle--purple');
    const greenCircle = document.querySelector('.rewards-page__bg-circle--green');

    const handleMouseMove = (e) => {
        const x = e.clientX / window.innerWidth;
        const y = e.clientY / window.innerHeight;

        // Move the blue circle - desktop
        blueCircle.style.left = `calc(-10vw + ${x * 20}vw)`;
        blueCircle.style.top = `calc(-30vw + ${y * 20}vw)`;

        // Move the purple circle - desktop
        purpleCircle.style.left = `calc(0px + ${x * -20}vw)`;
        purpleCircle.style.top = `calc(40vh + ${y * 40}vh)`;

        // Move the green circle - desktop
        greenCircle.style.left = `calc(-15vw + ${x * 40}vw)`;
        greenCircle.style.top = `calc(30vh + ${y * -40}vh)`;
    };

    const handleScroll = () => {
        const scrollY = window.scrollY;

        // Move the blue circle - mobile
        blueCircle.style.top = `calc(-324px + ${scrollY * 0.5}px)`;

        // Move the purple circle - mobile
        purpleCircle.style.top = `calc(324px + ${scrollY * 0.5}px)`;
        purpleCircle.style.right = `calc(0px - ${scrollY * 0.5}px)`;

        // Move the green circle - mobile
        greenCircle.style.top = `calc(200px + ${scrollY * 1.5}px)`;
        greenCircle.style.left = `calc(-180px + ${scrollY * 1.5}px)`;
    };

    if (window.innerWidth > 1024) {
        document.addEventListener('mousemove', handleMouseMove);
    } else {
        window.addEventListener('scroll', handleScroll);
    }

    window.addEventListener('resize', () => {
        if (window.innerWidth > 1024) {
            window.removeEventListener('scroll', handleScroll);
            document.addEventListener('mousemove', handleMouseMove);
        } else {
            document.removeEventListener('mousemove', handleMouseMove);
            window.addEventListener('scroll', handleScroll);
        }
    });

    const waitForElement = (selector, callback, checkInterval = 100) => {
        const element = document.querySelector(selector);
        if (element) {
            callback(element);
        } else {
            setTimeout(() => waitForElement(selector, callback, checkInterval), checkInterval);
        }
    };


    if (!document.body.classList.contains('customer-on')) {
        waitForElement('#ways-to-earn .yotpo-outer-tile', (widget) => {

            const earnTiles = document.querySelectorAll('#ways-to-earn .yotpo-outer-tile');
            console.log(earnTiles);

            earnTiles.forEach(tile => {
                tile.addEventListener('mouseenter', () => {
                    setTimeout(() => {
                        const signInButton = tile.querySelector('.yotpo-sign-in-button');
                        const signUpButton = tile.querySelector('.yotpo-sign-up-button');
                        const loginUrl = document.querySelector('[data-login-header]').getAttribute('data-login-header');

                        signInButton.style.pointerEvents = 'all';
                        signUpButton.style.pointerEvents = 'all';
                        
                        signInButton.addEventListener('click', event => {
                            event.preventDefault();
                            window.location.href = loginUrl;
                        });

                        signUpButton.addEventListener('click', event => {
                            event.preventDefault();
                            window.location.href = loginUrl;
                        });
                    }, 300);
                });

                tile.addEventListener('click', () => {
                    const signInButton = tile.querySelector('.yotpo-sign-in-button');
                    const signUpButton = tile.querySelector('.yotpo-sign-up-button');

                    const loginUrl = document.querySelector('[data-login-header]').getAttribute('data-login-header');

                    signInButton.style.pointerEvents = 'all';
                    signUpButton.style.pointerEvents = 'all';

                    signInButton.addEventListener('click', event => {
                        event.preventDefault();
                        window.location.href = loginUrl;
                    });

                    signUpButton.addEventListener('click', event => {
                        event.preventDefault();
                        window.location.href = loginUrl;
                    });
                });
            });
        });
    }

});

